import { useAuth, usePermissions } from "hooks";
import { Navigate } from "react-router-dom";

interface PrivateRoutePropsI {
    children: any;
    resource?: string;
}

const PrivateRoute = ({children, resource}:PrivateRoutePropsI) => {
    const auth = useAuth();
    const { can } = usePermissions();

    if (!auth) return <Navigate to="/" />;
    if (resource && !can(resource, "read")) return <Navigate to="/home" />;

    return children;
}
export default PrivateRoute;